import React from 'react';
import { getPageCreationResearchSystem, getWorkbookCreationResearchSystem, getProjectCreationResearchSystem } from '../../contexts/universal-creation-research/entity-creation-research-factory';
import UniversalCreationResearchSection from './UniversalCreationResearchSection';

// Page Creation Research Components
export const PageCreationResearchSection: React.FC<{ className?: string }> = ({ className }) => {
  const { useEntityCreationResearch, config } = getPageCreationResearchSystem();
  const context = useEntityCreationResearch();
  
  return (
    <UniversalCreationResearchSection 
      context={context}
      config={config}
      className={className}
    />
  );
};

// Workbook Creation Research Components (for future migration)
export const WorkbookCreationResearchSection: React.FC<{ className?: string }> = ({ className }) => {
  const { useEntityCreationResearch, config } = getWorkbookCreationResearchSystem();
  const context = useEntityCreationResearch();
  
  return (
    <UniversalCreationResearchSection 
      context={context}
      config={config}
      className={className}
    />
  );
};

// Project Creation Research Components (future)
export const ProjectCreationResearchSection: React.FC<{ className?: string }> = ({ className }) => {
  const { useEntityCreationResearch, config } = getProjectCreationResearchSystem();
  const context = useEntityCreationResearch();
  
  return (
    <UniversalCreationResearchSection 
      context={context}
      config={config}
      className={className}
    />
  );
};

// Export entity creation providers for easy use
export const PageCreationProvider = getPageCreationResearchSystem().Provider;
export const WorkbookCreationProvider = getWorkbookCreationResearchSystem().Provider;
export const ProjectCreationProvider = getProjectCreationResearchSystem().Provider;

// Export entity creation hooks for easy use
export const usePageCreationResearch = getPageCreationResearchSystem().useEntityCreationResearch;
export const useWorkbookCreationResearch = getWorkbookCreationResearchSystem().useEntityCreationResearch;
export const useProjectCreationResearch = getProjectCreationResearchSystem().useEntityCreationResearch;

// Export entity batch attach hooks for easy use
export const useBatchAttachPageResearch = getPageCreationResearchSystem().useBatchAttachResearch;
export const useBatchAttachWorkbookResearch = getWorkbookCreationResearchSystem().useBatchAttachResearch;
export const useBatchAttachProjectResearch = getProjectCreationResearchSystem().useBatchAttachResearch; 